import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';
import { lottieAnimation, SanityLottieAnimation } from './lottieAnimation';
import { SanityVideoEmbed, videoEmbed } from './videoEmbed';
import { SanityVideoLoop, videoLoop } from './videoLoop';

export const SanityMedia = z.union([
  SanityImage,
  SanityVideoLoop,
  SanityLottieAnimation,
]);
export type SanityMedia = z.infer<typeof SanityMedia>;

export const SanityIcon = z.object({
  _type: z.literal('icon'),
  title: z.string().optional().nullable(),
  svg: z.string(),
});
export type SanityIcon = z.infer<typeof SanityIcon>;

export const SanityMediaWithIcon = z.union([SanityMedia, SanityIcon]);
export type SanityMediaWithIcon = z.infer<typeof SanityMediaWithIcon>;

export const SanityMediaWithVideoEmbed = z.union([
  SanityImage,
  SanityVideoLoop,
  SanityLottieAnimation,
  SanityVideoEmbed,
]);
export type SanityMediaWithVideoEmbed = z.infer<
  typeof SanityMediaWithVideoEmbed
>;

// TODO: should we combine these two queries? Theres no harm using the videoEmbed one all the time except its going to have a type for videoEmbed that wont always be able to be there? The fact that we manually specify the type in the zod schema means that maybe its fine to combine them?

export const media = groq`{
  _type,
  _type == 'image' => ${image},
  _type == 'videoLoop' => ${videoLoop},
  _type == 'lottieAnimation' => ${lottieAnimation},
}`;

export const mediaWithIcon = groq`{
  _type,
  _type == 'image' => ${image},
  _type == 'videoLoop' => ${videoLoop},
  _type == 'lottieAnimation' => ${lottieAnimation},
  _type == 'reference' => @-> {
    _type,
    title,
    svg,
  },
}`;

export const mediaWithVideoEmbed = groq`{
  _type,
  _type == 'image' => ${image},
  _type == 'videoLoop' => ${videoLoop},
  _type == 'lottieAnimation' => ${lottieAnimation},
  _type == 'videoEmbed' => ${videoEmbed},

}`;
